import { useMemo } from 'react';
import { useStore, useSelector } from 'react-redux';

const useMavLinkAddress = () => {
  const store = useStore();

  const getAddress = (robotId) => {
    const addressData = store.getState().address[robotId]?.FC;
    if (!addressData) return null;

    const { sysId, compId } = addressData;
    return [sysId, compId];
  };

  return { getAddress };
};

export const useAddressSelector = (robotId) => {
  const addressData = useSelector((state) => state.address[robotId]?.FC);

  return useMemo(() => {
    if (!addressData) return null;

    const { sysId, compId } = addressData;
    return [sysId, compId];
  }, [addressData]);
};

export default useMavLinkAddress;
